/*
 * @Description: Description
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2025-04-10 17:20:12
 * @LastEditors: FJW
 * @LastEditTime: 2025-04-10 17:34:36
 */
const UNI_APP = {
	VUE_APP_BASE_API: process.env.VUE_APP_BASE_API,
	VUE_APP_SHOP_BASE_API: process.env.VUE_APP_SHOP_BASE_API
}

if (process.env.NODE_ENV === 'development') {
	UNI_APP.VUE_APP_BASE_API = "/api"
	UNI_APP.VUE_APP_SHOP_BASE_API = "/shopApi"
}

export default UNI_APP